import {
  GET_ORGANIZATIONS_REQUEST,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATIONS_FAILED,
  UPDATE_ORGANIZATION_REQUEST,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAILED,
  DELETE_ORGANIZATION_REQUEST,
  DELETE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_FAILED,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
};

const organizationsListReducer = (state = initialState, {
  type, error, data, meta, organization, deletedId,
}) => {
  switch (type) {
    case GET_ORGANIZATIONS_REQUEST:
      return { ...state, loading: true };
    case GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        loading: false,
      };
    case GET_ORGANIZATIONS_FAILED:
      return { ...state, loading: false, error };
    case UPDATE_ORGANIZATION_REQUEST:
      return { ...state, loading: true };
    case UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        data: state.data.map((org) => (org.id === organization.id ? organization : org)),
        loading: false,
      };
    case UPDATE_ORGANIZATION_FAILED:
      return {
        ...state, loading: false, error, data: [...state.data],
      };
    case DELETE_ORGANIZATION_REQUEST:
      return { ...state, loading: true };
    case DELETE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        data: state.data.filter((org) => org.id !== deletedId),
        loading: false,
      };
    case DELETE_ORGANIZATION_FAILED:
      return {
        ...state, loading: false, error, data: [...state.data],
      };
    default:
      return state;
  }
};

export default organizationsListReducer;
